import axios from "axios";
import { cmsEnv, headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/custom/useToast";

export const fetchJoinAsFacultyDetails = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/community-join-as-faculty-details`,
      {
        headers: {
          ...headers,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(error.response.data.error.message);
  }
};

export const fetchAreasMajorsTab = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/community-join-as-faculty-academic-areas-majors-tab?sort=sort_order:asc`,
      {
        headers: {
          ...headers,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    dynamicFailed(error.response.data.error.message);
  }
};

export const fetchWhoIsUNepalFor = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/community-join-as-faculty-who-is-unepal-for-tab?sort=sort_order:asc`,
     {
        headers: {
          ...headers,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    dynamicFailed(error.response.data.error.message);
  }
};

export const fetchWhyJoinUNepal = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/community-join-as-faculty-why-join-unepal-tab?sort=sort_order:asc`,
     {
        headers: {
          ...headers,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    dynamicFailed(error.response.data.error.message);
  }
};
